import VehiclesView from "./view";
import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "@/redux/reducers/Models";
import { useState } from "react";
import { authorize, setUser } from "@/redux/ducks/user";
import { useNavigate } from "react-router-dom";

export default function Vehicles() {
  const navigate = useNavigate();
  const TIMEOUT = 500;

  const dispatch = useDispatch();
  const user = useSelector((state: ReducersTypes) => state.userReducer);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [plate, setPlate] = useState<string>(user?.plate as string ?? "");

  const toggleModal = () => setIsVisibleModal(isVisibleModal => !isVisibleModal);

  const goBack = () => navigate(-1);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target;
    
    setPlate(value);
  }

  const handleAuthorize = (success: boolean, errorMessage?: string) => {
    setIsLoading(false);

    if (!success) {
      if (errorMessage === "timeout") setError(true);
      toggleModal();
      return;
    }

    dispatch(
      setUser({
        plate,
        requestId: null,
        debts: null,
        cart: null,
      })
    );
    
    setTimeout(() => {
      goBack();
    }, TIMEOUT);
  }

  const change = () => {
    if (isLoading || plate?.length < 8 || plate?.toLowerCase() === String(user?.plate ?? "")?.toLowerCase()) return;

    setIsLoading(true);

    dispatch(
      authorize({
        plate,
        callback: handleAuthorize,
      })
    );
  }

  return (
    <VehiclesView 
      goBack={goBack}
      change={change}
      plate={plate}
      onChange={onChange}
      isLoading={isLoading}
      isVisibleModal={isVisibleModal}
      error={error}
      toggleModal={toggleModal}
    />
  );
}